import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { Footer } from '../../../common/footer';
import { HomeNavbar } from '../../../common/home-navbar';
import { MessageStore } from './stores/MessageStore';
import { Spinner } from '../../../common/spinner';
import styles from './Message.css';
import { InformationAndQuestions } from '../../../common/information-and-questions';
import { ParamsHelper } from '../../../helpers/ParamsHelper';
import { ERROR_CODES } from '../../../models/ApiError';
import { SecondaryButton } from '../../../common/secondary-button';
import { goToPage, routeNaming } from '../../../routes';
import { SEO } from '../../../common/seo';

const IPropTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

class Message extends React.Component {
  static backToHome() {
    goToPage(routeNaming.HOME);
  }

  componentDidMount() {
    MessageStore.getInformation(ParamsHelper.parseQueryParams(this.props.location.search).t);
  }

  componentWillUnmount() {
    MessageStore.clearErrors();
  }

  static renderInternalError() {
    return (
      <p className={styles.errorMessage}>
        Estamos experimentando algunas dificultades en nuestro sitio.
        Por favor intente nuevamente en unos momentos.
      </p>
    );
  }

  static renderError() {
    return (
      <p className={styles.errorMessage}>
        Ha ocurrido un error, por favor intente nuevamente.
      </p>
    );
  }

  static renderInvalidActionError() {
    return (
      <p className={styles.errorMessage}>
        El estado del servicio no permite realizar esta acción.
      </p>
    );
  }

  render() {
    const loading = !!MessageStore.loadingMessage;

    const dataLoaded = MessageStore.message !== null;

    const messageError = dataLoaded ? MessageStore.message.error : null;

    return (
      <div className={styles.container}>
        <SEO
          title="Servicio PANAVOX"
          description="Accede a toda la información relevante sobre Carlos Gutiérrez S.A, nuestros servicios, políticas y cómo podemos ayudarte. Encuentra detalles sobre nuestros productos, condiciones de uso, privacidad, envíos y más. Estamos comprometidos a ofrecerte la mejor experiencia, brindándote transparencia y claridad en todos nuestros procesos. Si tienes preguntas o dudas, esta sección es tu recurso principal para obtener respuestas. Descubre todo lo que necesitas saber y disfruta de una experiencia de compra segura y satisfactoria con nosotros"
          type="website"
        />
        <HomeNavbar />
        <div className={styles.mainWrapper}>
          {
            loading
            ? (
              <div className={styles.spinnerWrapper}>
                <Spinner className={styles.spinner} />
              </div>
            )
            : (
              <React.Fragment>
                {
                  dataLoaded && !messageError &&
                    <div className={styles.titleContainer}>
                      <h1 className={styles.mainTitle}> {MessageStore.message.title} </h1>
                    </div>
                }
                <div className={styles.mainContent}>
                  {
                    dataLoaded && !messageError &&
                      <InformationAndQuestions sections={MessageStore.message.sections} />
                  }
                  {
                    !loading && messageError &&
                    <p className={styles.errorMessage}>{messageError}</p>
                  }
                  {
                    MessageStore.error &&
                    Message.renderError()
                  }
                  {
                    MessageStore.internalError &&
                    Message.renderInternalError()
                  }
                  {
                    MessageStore.apiError === ERROR_CODES.INVALID_SERVICE_ACTION &&
                    Message.renderAPIError()
                  }
                </div>
                <div className={styles.submitSection}>
                  <SecondaryButton
                    type="submit"
                    onClick={Message.backToHome}
                  >
                    Página principal
                  </SecondaryButton>
                </div>
              </React.Fragment>
            )
          }
        </div>
        <Footer />
      </div>
    );
  }
}

Message.propTypes = IPropTypes;

const ObserveredMessage = withRouter(observer(Message));

export { ObserveredMessage as Message };



// WEBPACK FOOTER //
// ./src/pages/information/message/Message.jsx